// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__qEg8R"};